import clsx from 'clsx'

import { Headline } from 'src/components/Headline/Headline'
import { Image } from 'src/components/Image/Image'
import { Text } from 'src/components/Text/Text'
import { config } from 'src/config'
import { useLocale } from 'src/contexts/LocaleContext'
import { formatDate } from 'src/functions/dates/formatDate'
import { POST_CARD } from 'src/selectors'

import styles from './PostCards.module.scss'

import type { Post } from 'src/types/Post'

interface PostCardProps {
  post: Post
  preload: boolean
  lazy: boolean
}

export const PostCard = ({ post, preload = false, lazy = false }: PostCardProps) => {
  const { locale, language } = useLocale()
  const { id, slug, header, category, date, title, excerpt } = post

  return (
    <a href={`/${language}/b/${slug}`} className={clsx(styles.card, styles.hasKenburns)} key={id} data-cy={POST_CARD}>
      <div className={styles.imgKenburns}>
        <Image
          identifier={header.image ? header.image.id : config.imagePlaceholderUploadcareId}
          srcSet={[400, 800]}
          sizes="400px"
          width="392"
          height="255"
          alt={slug}
          responsive
          preload={preload}
          lazy={lazy}
        />
      </div>
      <div className={styles.info}>
        <Text variant="p" small className={styles.tag}>
          {category?.name || '#Coffee Circle'}
        </Text>
        <Text variant="p" small className={styles.date} suppressHydrationWarning>
          {formatDate(date, locale)}
        </Text>
      </div>
      <Headline variant="h2" className={clsx('intro', styles.title)}>
        <span dangerouslySetInnerHTML={{ __html: title }} suppressHydrationWarning />
      </Headline>
      <Text variant="p" small className={styles.content}>
        {excerpt}
      </Text>
    </a>
  )
}
